import { useQuery } from '@tanstack/react-query';
import { onboardingApi, onboardingKeys } from '@/features/onboarding/api/onboarding.api';
import { useAuthStore } from '@/store/auth';

export function useOnboardingProgress() {
  const userId = useAuthStore((state) => state.user?.id);

  return useQuery({
    queryKey: onboardingKeys.progress(userId),
    queryFn: onboardingApi.getProgress,
    enabled: Boolean(userId),
    staleTime: 0,
  });
}
